// extracted by mini-css-extract-plugin
export default {"container":"Order_container__bBc3C","body":"Order_body__psDer","buttonAction":"Order_buttonAction__Pr9sa"};